 import Runtime from './dwd-runtime'

 const runtime = new Runtime()
 runtime.mountApis()

 export default runtime
